import moment from 'moment-timezone';

export function convertToTimeZone(date, timeZone) {
    return moment(date).tz(timeZone);
}
